import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import ClearIcon from '@mui/icons-material/Clear'
import styles from './styles.module.css'

interface DateFilterProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

function DateFilter({
  value,
  onChange,
  placeholder = 'Select date',
  disabled,
}: DateFilterProps) {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    onChange(event.target.value)
  }

  function handleClear() {
    onChange('')
  }

  return (
    <div>
      <TextField
        className={styles.dropDownSelect}
        type='date'
        fullWidth
        size='small'
        value={value}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
        slotProps={{
          inputLabel: {
            shrink: true,
          },
          input: {
            endAdornment: value ? (
              <InputAdornment position='end'>
                <IconButton
                  size='small'
                  onClick={handleClear}
                  sx={{ padding: '2px', marginRight: '-8px' }}
                >
                  <ClearIcon sx={{ fontSize: '16px', color: '#777777' }} />
                </IconButton>
              </InputAdornment>
            ) : null,
            sx: {
              fontWeight: 'bold',
              textAlign: 'left',
              color: value === '' ? '#777777' : 'inherit',
            },
          },
        }}
        sx={{
          minWidth: '100px',
          maxWidth: '200px',
          display: 'flex',
          justifyContent: 'flex-start',
          backgroundColor: '#eeeeee',
          height: '35px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& input[type="date"]::-webkit-calendar-picker-indicator': {
            filter: value === '' ? 'invert(50%)' : 'none',
          },
        }}
      />
    </div>
  )
}

export default DateFilter
